import { Directive, OnDestroy } from '@angular/core';
import { MonoTypeOperatorFunction, Subject, takeUntil } from 'rxjs';

@Directive()
export abstract class UnsubscribeComponent implements OnDestroy {
    private destroy$: Subject<boolean> = new Subject<boolean>();

    takeUntilDestroyed<T>(): MonoTypeOperatorFunction<T> {
        return takeUntil(this.destroy$);
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
